/* eslint-disable */
import {
  createTransactionData,
  getDriverOpenTransactionsInfo,
  getDriversIncomeHistoryData
} from '@/requests/driversIncome'
import { callUpdateScheduleFiveMinutely } from '@/requests/tasker'
import {
  ADD_DETAILS_TO_INCOME,
  ADD_RETENTION,
  ADD_SURCHARGE,
  CANCEL_RETENTION,
  CANCEL_SURCHARGE,
  CHANGE_PERSCENT_BY_ID,
  COMMIT_RETENTION,
  COMMIT_SURCHARGE,
  INIT_HIST_TABLE,
  INIT_NOT_CALKED_DAYS,
  REMOVE_RETENTION,
  REMOVE_TABLE_ITEM,
  SET_META_CARS,
  SET_COMPENSATION,
  SET_CURRENT_REGION_PARK_ID,
  SET_DRIVER_ID,
  SET_FILTERS,
  SET_HISTORY_SETTINGS_CHANGES,
  START_LOADING,
  STOP_LOADING,
  UPDATE_RETENTION,
  UPDATE_SCHEDULE,
  UPDATE_TENANS_INFO_BY_MAX_RETENTIONS, SET_CAR_IDS,
} from '@/store/mutationsTypes'
// import { formulaCheck } from '@/requests/configurator'
import globalMixin from '@/mixin/global'
import Api from '@/repository/index'
import {
  showDefaultErrorMessage,
  showErrorMessage
} from '@/utils/createMessage'
import { Message } from 'element-ui'
import { confirmWarning } from '@/core/helpers/messageHelper'
import { WorkerRepository } from '@/modules/worker/Repositories/Worker.repository'
import { dispatch } from 'vuex-smart-module/lib/context'

const { getUtcFromDate } = globalMixin.methods
const moment = require('moment')

const getDateAndShiftByTimeHelper = (b, t) => {
  const date = moment(t).startOf('day')
  const formattedDate = date.format('YYYY-MM-DDTHH:mm:ss[Z]')

  const nowHour = t.getHours()

  if (b.fulldayBorderHour !== undefined) {
    if (nowHour >= b.fulldayBorderHour) {
      return [formattedDate, 'fullday']
    } else {
      const previousDate = moment(date).startOf('day').subtract(1, 'days')
      return [previousDate.format('YYYY-MM-DDTHH:mm:ss[Z]'), 'fullday']
    }
  }

  if (b.nightBorderHour === 24) {
    if (nowHour >= 0 && nowHour < b.morningBorderHour) {
      const previousDate = moment(date).startOf('day').subtract(1, 'days')
      return [previousDate.format('YYYY-MM-DDTHH:mm:ss[Z]'), 'night']
    }

    if (nowHour >= b.morningBorderHour) {
      return [formattedDate, 'morning']
    }
  }

  if (nowHour >= b.nightBorderHour) {
    return [formattedDate, 'night']
  }

  if (nowHour < b.morningBorderHour) {
    const previousDate = moment(date).startOf('day').subtract(1, 'days')
    return [previousDate.format('YYYY-MM-DDTHH:mm:ss[Z]'), 'night']
  }

  return [formattedDate, 'morning']
}

export const checkShiftDateIsBeforeCurrentShiftDateHelper = (target, current) => {
  const {
    change: currentShiftType,
    date: currentDateString
  } = current
  const {
    change: targetShiftType,
    date: targetDateString
  } = target
  const currentDate = new Date(currentDateString).setUTCHours(0, 0, 0, 0)
  const targetDate = new Date(targetDateString).setUTCHours(0, 0, 0, 0)

  if (targetDate < currentDate) return true

  if (targetDate === currentDate) {
    if (targetShiftType === 'morning' && currentShiftType === 'night') {
      return true
    }

    if (targetShiftType === 'morning' && currentShiftType === 'fullday') {
      return true
    }
  }

  return false
}

const state = () => ({
  isLoading: true,
  table: [],
  history: [],
  filterDriverId: [],
  notCalkedDays: [],
  filters: {},
  currentRegionParkID: null,
  regionParksMeta: {},
  carsMeta: [],
  carIds: [],
  cars: []
})
const helpers = {
  GET_TENANS_INFO_BY_MAX_RETENTIONS ({
    state_table,
    scheduleId,
    maxRetentions,
    retentionTypes
  }) {
    if (!retentionTypes?.length || !maxRetentions?.length) return state_table
    const getTenantsIndexByScheduleId = state_table.findIndex(
      (d) => d.schedule.id === scheduleId
    )
    if (getTenantsIndexByScheduleId === -1) return false
    const { retentions_to_exec } = state_table[getTenantsIndexByScheduleId] // retentions
    return retentions_to_exec.reduce(
      (acc, retention_value) => {
        const getereteRetentionToExec = (value, current_amount, amount) => {
          const calc_current_by_max = amount - value
          const current_amount_g = retention_value?.newSum
            ? retention_value.newSum
            : amount - current_amount < value
              ? current_amount
              : calc_current_by_max
          return {
            fixed_sum: false,
            // amount: amount - value,
            current_amount: current_amount_g,
            diableCalc: true
          }
        }
        const {
          type,
          amount
        } = retention_value //  amount, current_amount
        const getNameRetentionById = retentionTypes.filter(
          (x) => x.id === type
        )[0]?.name
        const checkRetentionOnListMaxRetentions = maxRetentions.filter(
          (x) => x.name === getNameRetentionById
        )

        if (checkRetentionOnListMaxRetentions?.length) {
          const { value } = checkRetentionOnListMaxRetentions[0]
          if (amount > value && !retention_value?.event_at) {
            acc.retentions_to_exec = [
              ...acc.retentions_to_exec,
              {
                ...retention_value,
                ...getereteRetentionToExec(
                  value,
                  retention_value.current_amount,
                  amount
                )
              }
            ]
            return acc
          } else {
            acc.retentions_to_exec = [
              ...acc.retentions_to_exec,
              { ...retention_value }
            ]
            return acc
          }
        }
        acc.retentions_to_exec = [
          ...acc.retentions_to_exec,
          { ...retention_value }
        ]
        return acc
      },
      {
        retentions_to_exec: [],
        retentions: []
      }
    )
  },
  GET_SORT_BY_DRIVER_NAME_AND_DATE (data) {
    return data.sort((a, b) => {
      const nameComparison = a.schedule.driverName.localeCompare(
        b.schedule.driverName
      )
      if (nameComparison === 0) {
        return a.schedule.date.localeCompare(b.schedule.date)
      }

      return nameComparison
    })
  }
}
const getters = {
  notCommitedDrivers: (state, getters) => {
    return helpers.GET_SORT_BY_DRIVER_NAME_AND_DATE(
      getters.getAllDriversByFilter.filter((d) => !d.schedule.isCalculated)
    )
  },
  commitedDrivers: (state, getters) =>
    helpers.GET_SORT_BY_DRIVER_NAME_AND_DATE(
      getters.getAllDriversByFilter.filter(
        (d) =>
          d.schedule.isCalculated && d.schedule.calculationType === 'registry'
      )
    ),
  commitedBalanceDrivers: (state, getters) =>
    helpers.GET_SORT_BY_DRIVER_NAME_AND_DATE(
      getters.getAllDriversByFilter.filter(
        (d) =>
          d.schedule.isCalculated &&
          d.schedule.calculationType === 'change_balance'
      )
    ),
  getAllDriversForFilter: (state) => {
    const mappedTable = state.table.map((d, idx) => {
      return {
        driverName: d.schedule.driverName,
        id: d.schedule.id
      }
    })
    const mappedOnlyNames = state.table.map((d) => d.schedule.driverName)
    const newSetNames = [...new Set(mappedOnlyNames)]
    const redusedNamesDrivers = newSetNames.reduce((acc, driverName) => {
      const checkDublicate = mappedTable
        .filter((value_filter) => value_filter.driverName === driverName)
        .map((v) => v.id)
      acc.push({
        driverName: driverName,
        ids: [...checkDublicate]
      })
      return acc
    }, [])
    return redusedNamesDrivers
  },
  getAllCarsForFilter: (state) => {
    const mappedCars = state.carsMeta.map((d, idx) => {
      return {
        id: d.id,
        number: d.number
      }
    })
    const mappedOnlyNum = state.carsMeta.map((d) => d.number)
    const newSetNumbers = [...new Set(mappedOnlyNum)]
    const redusedNumCars = newSetNumbers.reduce((acc, numCar) => {
      const checkDublicate = mappedCars
        .filter((value_filter) => value_filter.number === numCar)
        .map((v) => v.number)
      acc.push({
        number: numCar,
        ids: [...checkDublicate]
      })
      return acc
    }, [])
    return redusedNumCars
  },
  getSurchargesByDriverId: (state) => (driverID) =>
    state.table.filter((d) => !d.schedule.driverId === driverID),
  getByDriverId: (state) => (driverID) =>
    state.table.filter((d) => d.schedule.driverId === driverID),
  getDataByScheduleID: (state) => (id) =>
    state.table.filter((d) => d.schedule.id === id),
  getTableElementByScheduleId: (state) => (sheduleId) =>
    state.table.filter((d) => d.schedule.id === sheduleId)[0],
  getAllDriversByFilter: (state, getters, rootState, rootGetters) => {
    const getMaxRetentionsTypes = rootState.settings.retentionsMinMax?.max
    const {
      maxRetentions,
      retentionTypes
    } = {
      maxRetentions: getMaxRetentionsTypes,
      retentionTypes: rootGetters['settings/getTransactionTypesToDropdown']
    }
    if (!state.filterDriverId.length) {
      const tets = state.table.reduce((accDriver, valueDriver) => {
        //
        const {
          id: scheduleId,
          driverId
        } = valueDriver.schedule
        const xuita = helpers.GET_TENANS_INFO_BY_MAX_RETENTIONS({
          state_table: state.table,
          scheduleId,
          maxRetentions,
          retentionTypes
        })
        const return_v = xuita?.retentionsExecs
          ? {
            ...valueDriver,
            retentionsExecs: xuita.retentionsExecs
          }
          : valueDriver
        const driverIsDublicat =
          state.table.filter((x) => x?.schedule?.driverId === driverId).length >
          1
        return [
          ...accDriver,
          {
            ...return_v,
            isDublicate: driverIsDublicat
          }
        ]
        //
      }, [])
      return tets.sort((a, b) => a.schedule?.driverId - b.schedule?.driverId)
    }
    const getOnluIds = state?.filterDriverId.reduce((acc, value) => {
      return [...acc, ...value.ids]
    }, [])
    const filtredDrivers = state.table.filter((val) =>
      getOnluIds.some((v) => val.schedule.id === v)
    )

    return filtredDrivers.reduce((accDriver, valueDriver) => {
      //
      const { id: scheduleId } = valueDriver.schedule
      const xuita = helpers.GET_TENANS_INFO_BY_MAX_RETENTIONS({
        state_table: state.table,
        scheduleId,
        maxRetentions,
        retentionTypes
      })
      const return_v = xuita?.retentionsExecs
        ? {
          ...valueDriver,
          retentionsExecs: xuita.retentionsExecs
        }
        : valueDriver
      return [...accDriver, { ...return_v }]
      //
    }, [])
  },
  getHistoryPercentByScheduleId: (state) => (prop_id, change) => {
    return (
      state.history.filter(
        (a) =>
          a.name === 'fixed_percent' &&
          a.shiftId === prop_id &&
          a.change === change
      ) || []
    )
  },
  getRetentionsByScheduleId: (state) => (sheduleId) => {
    const {
      retentionsExecs,
      retentions,
      schedule
    } =
    state.table.filter((item) => item.schedule.id === sheduleId)[0] || []

    return {
      retentionsExecs,
      retentions,
      schedule
    }
  }
}

const mutations = {
  [SET_META_CARS]: (state, cars) => {
    state.carsMeta = cars
  },
  [SET_CAR_IDS]: (state, cars) => {
    state.carIds = cars
  },
  [INIT_HIST_TABLE]: (state, {
    data,
    prevShiftId,
    dataDetails
  }) => {
    const localStateTable = data

    const getDataMergeByDetails = () => {
      const getIndexTarget = localStateTable.findIndex(
        (x) => x.schedule.id === prevShiftId
      )
      const getClonedTarget = localStateTable[getIndexTarget]

      const getResult = {
        ...getClonedTarget,
        ...dataDetails,
      }

      const getResultValidate = getResult?.schedule?.isCalculated
      const base_state_retentions = getResultValidate
        ? getResult?.retentionsHistories || []
        : getResult?.retentionsExecs || []
      return {
        ...getResult,
        getIndexTarget,
        base_state_retentions,
      }
    }
    if (prevShiftId) {
      const {
        getIndexTarget,
        ...details
      } = getDataMergeByDetails()
      localStateTable[getIndexTarget] = {
        ...localStateTable[getIndexTarget],
        ...details,
      }
    }

    state.table = localStateTable.slice()
  },
  [ADD_DETAILS_TO_INCOME]: (state, {
    data,
    shiftId
  }) => {
    const getIndexTarget = state.table.findIndex(
      (x) => x.schedule.id === shiftId
    )
    const getClonedTarget = state.table[getIndexTarget]

    const getResult = {
      ...getClonedTarget,
      ...data,
    }

    const getResultValidate = getResult?.schedule?.isCalculated
    const base_state_retentions = getResultValidate
      ? [...getResult?.retentionsHistories]
      : [...getResult?.retentionsExecs]

    state.table = [
      ...state.table.filter((x) => x.schedule.id !== shiftId),
      {
        ...getResult,
        base_state_retentions,
      },
    ]
  },
  [SET_HISTORY_SETTINGS_CHANGES]: (state, history) => {
    state.history = history
  },
  [SET_CURRENT_REGION_PARK_ID]: (state, value) => {
    state.currentRegionParkID = value
  },
  [SET_DRIVER_ID]: (state, ids) => {
    state.filterDriverId = ids
  },
  [START_LOADING]: (state) => {
    state.isLoading = true
  },

  [STOP_LOADING]: (state) => {
    state.isLoading = false
  },
  [SET_FILTERS]: (state, data) => {
    state.filters = data
  },
  [INIT_NOT_CALKED_DAYS]: (state, arr) => {
    state.notCalkedDays = arr
  },

  [REMOVE_TABLE_ITEM]: (state, scheduleId) => {
    const index = state.table.findIndex(
      (item) => item.schedule.id === scheduleId
    )

    state.table.splice(index, 1)
  },

  [REMOVE_RETENTION]: (state, {
    transactionId,
    driverId,
    lastSheduleId
  }) => {
    const driverIndex = state.table.findIndex(
      (d) => d.schedule.id === lastSheduleId
    )
    // Удаление из retentions
    const retentionIndex = state.table[driverIndex].retentions.findIndex(
      (r) => r.id === transactionId
    )

    const getParentId = state.table[driverIndex].retentions.find(
      (x) =>
        x.parent_id === state.table[driverIndex].retentions[retentionIndex].id
    )
    if (getParentId) {
      const getIndexByParentIdFind = state.table[
        driverIndex
        ].retentions.findIndex((r) => r.id === getParentId.id)
      if (getIndexByParentIdFind !== -1) {
        state.table[driverIndex].retentions.splice(getIndexByParentIdFind, 1)
      }
    }
    // state.table[driverIndex].retentions.splice(retentionIndex, 1)

    if (retentionIndex !== -1) {
      state.table[driverIndex].retentions.splice(retentionIndex, 1)
    }

    // Удаление из retentions_to_exec
    const retentionToExecIndex = state.table[
      driverIndex
      ].retentions_to_exec.findIndex((r) => r.id === transactionId)
    if (retentionToExecIndex !== -1) {
      state.table[driverIndex].retentions_to_exec.splice(
        retentionToExecIndex,
        1
      )
    }
  },

  [ADD_RETENTION]: (state, {
    scheduleId,
    retention
  }) => {
    const index = state.table.findIndex((d) => d.schedule.id === scheduleId)

    state.table[index].retentions.push({
      ...retention,
      newSum: null,
    })
  },

  [UPDATE_RETENTION]: (state, {
    driverId,
    retention
  }) => {
    const index = state.table.findIndex((d) => d.schedule.driver === driverId)

    state.table[index].retentions = [
      ...state.table[index].retentions.filter((r) => r.id !== retention.id),
      {
        ...retention,
        newSum: null,
      },
    ]
  },
  [UPDATE_SCHEDULE]: (state, {
    scheduleId,
    formulaResponse
  }) => {
    const index = state.table.findIndex((d) => d.schedule.id === scheduleId)
    if (index === -1) return false
    state.table[index].schedule = {
      ...state.table[index].schedule,
      ...formulaResponse,
    }
    // state.table[index] = state.table[index].slice()
  },

  AddRegionParksMeta: (state, dto) => {
    state.regionParksMeta = {
      ...state.regionParksMeta,
      [dto.regionParkId]: {
        ...dto,
      },
    }
  },

  [COMMIT_RETENTION]: (state, {
    driverId,
    retention,
    sheduleId
  }) => {
    const index = state.table.findIndex((d) => d.schedule.id === sheduleId)
    const retentionIndex = state.table[index].retentionsExecs.findIndex(
      (e) => e.transactionId === retention.transactionId
    )
    if (retentionIndex === -1) {
      state.table[index].retentionsExecs.push(retention)
      // state.table[index].retentions_to_exec = [...state.table[index].retentions_to_exec, { ...retention }]
    } else {
      state.table[index].retentionsExecs.splice(index, 1, retention)
    }
    state.table = state.table.slice()
    // retentionIndex === -1
    //   ? state.table[index].retentions_to_exec.push(retention)
    //   : state.table[index].retentions_to_exec.splice(index, 1, retention)
  },

  [CANCEL_RETENTION]: (state, {
    driverId,
    retentionId,
    scheduleId
  }) => {
    const scheduleIndex = state.table.findIndex((d) => d.schedule.id === scheduleId)
    const retentionIndex = state.table[scheduleIndex].retentionsExecs.findIndex(
      (r) => r.transactionId === retentionId
    )
    // Удалить из retentions_to_exec
    state.table[scheduleIndex].retentionsExecs.splice(retentionIndex, 1)
    // state.table[index].retentions_to_exec = state.table[index].retentions_to_exec.splice(getIndexRetentionsToExec, 1)
  },

  [CHANGE_PERSCENT_BY_ID]: (state, {
    id,
    newPercent
  }) => {
    const index = state.table.findIndex(
      (d) => Number(d.schedule.id) === Number(id)
    )

    state.table[index].schedule.driverPercent = newPercent
  },

  [SET_COMPENSATION]: (state, {
    driverId,
    compensation
  }) => {
    const index = state.table.findIndex(
      (d) => d.schedule.driverId === driverId
    )
    state.table[index].schedule.driverCompensation = compensation
  },

  [ADD_SURCHARGE]: (state, {
    scheduleId,
    surcharge
  }) => {
    const index = state.table.findIndex((d) => d.schedule.id === scheduleId)

    if (index !== -1) state.table[index].surcharges.push(surcharge)
  },
  [UPDATE_TENANS_INFO_BY_MAX_RETENTIONS]: (
    state,
    {
      scheduleId,
      maxRetentions,
      retentionTypes
    }
  ) => {
    const getTenantsIndexByScheduleId = state.table.findIndex(
      (d) => d.schedule.id === scheduleId
    )
    if (getTenantsIndexByScheduleId === -1) return false
    const { retentionsExecs } = state.table[getTenantsIndexByScheduleId] // retentions
    const test = (retentionsExecs ?? []).reduce(
      (acc, retention_value) => {
        const getereteRetentionToExec = (value, current_amount, amount) => {
          const calc_current_by_max = amount - value
          const current_amount_g = retention_value?.newSum
            ? retention_value.newSum
            : amount - current_amount < value
              ? current_amount
              : calc_current_by_max
          return {
            fixed_sum: false,
            // amount: amount - value,
            current_amount: current_amount_g,
            diableCalc: true,
          }
        }
        const {
          type,
          amount
        } = retention_value //  amount, current_amount
        const getNameRetentionById = retentionTypes.filter(
          (x) => x.id === type
        )[0]?.name
        const checkRetentionOnListMaxRetentions = maxRetentions.filter(
          (x) => x.name === getNameRetentionById
        )

        if (checkRetentionOnListMaxRetentions?.length) {
          const { value } = checkRetentionOnListMaxRetentions[0]
          if (amount > value && !retention_value?.event_at) {
            acc.retentions_to_exec = [
              ...acc.retentions_to_exec,
              {
                ...retention_value,
                ...getereteRetentionToExec(
                  value,
                  retention_value.current_amount,
                  amount
                ),
              },
            ]
            return acc
          } else {
            acc.retentions_to_exec = [
              ...acc.retentions_to_exec,
              { ...retention_value },
            ]
            return acc
          }
        }
        acc.retentions_to_exec = [
          ...acc.retentions_to_exec,
          { ...retention_value },
        ]
        return acc
      },
      {
        retentions_to_exec: [],
        retentions: [],
      }
    )
    state.table[getTenantsIndexByScheduleId].retentionsExecs =
      test.retentions_to_exec
  },
}

const actions = {
  async setCalcComment ({}, data) {
    try {
      const response = await Api.tenants.income.setCalcComment(data)

      if (response.success) {
        Message({
          message: 'Комментарий успешно обновлен!',
          type: 'success',
          duration: 5 * 1000
        })
      }
    } catch (e) {
      Message({
        message: 'Произошла ошибка',
        type: 'error',
        duration: 5 * 1000
      })
    }
  },

  checkCanDriversCalculate ({ state }, schedule) {
    const current = state.regionParksMeta[schedule.regionParkId]
    return checkShiftDateIsBeforeCurrentShiftDateHelper(schedule, {
      date: current.currentShiftDateInPark,
      change: current.currentShiftTypeInPark,
    })
  },

  setCurrentRegionParkID ({ commit }, region_park_id) {
    commit('SET_CURRENT_REGION_PARK_ID', region_park_id)
  },
  async updateCashSchedulesByScheduleId (
    {
      commit,
      dispatch
    },
    {
      scheduleId,
      data,
      schedule_date
    }
  ) {
    try {
      await Api.schedule.index.setCashFieldOnScheduleRecord(scheduleId, data)
      await dispatch(
        'worker/updateScheduleTask',
        { scheduleId },
        { root: true }
      )
      await dispatch('fetchDriversIncomeHistory')

      Message({
        type: 'success',
        message: 'Наличка обновленна'
      })

      // commit(UPDATE_SCHEDULE, { scheduleId, formulaResponse: data })
    } catch (error) {
      Message({
        message: 'Произошла ошибка!',
        type: 'error',
        duration: 5 * 1000
      })
    }
  },
  async updateRetentionByMax (
    {
      commit,
      rootState,
      rootGetters
    },
    { scheduleId }
  ) {
    const getMaxRetentionsTypes = rootState.settings.retentionsMinMax?.maxes
    if (!getMaxRetentionsTypes) return
    commit(UPDATE_TENANS_INFO_BY_MAX_RETENTIONS, {
      scheduleId,
      maxRetentions: getMaxRetentionsTypes,
      retentionTypes: rootGetters['settings/getTransactionTypesToDropdown']
    })
  },
  async deleteFineTransaction ({
    state,
    dispatch
  }, data) {
    try {
      const {
        transactionId,
        shiftId
      } = data
      const response = await Api.tenants.transaction.deleteFineTransaction({
        transactionId
      })

      await dispatch(
        'worker/updateScheduleTask',
        { scheduleId: shiftId },
        { root: true }
      )
      await dispatch('fetchDriversIncomeHistory', { prevShiftId: shiftId })

      Message({
        type: 'success',
        message: 'Успешно удалено'
      })

      return response

    } catch (e) {
      showDefaultErrorMessage()
    }
  },
  async updateRetentionByFormula (
    {
      commit,
      dispatch,
      rootState,
      rootGetters,
      rootActions,
      state
    },
    { scheduleId }
  ) {
    try {
      const getDataByScheduleID = state.table.findIndex(
        (d) => d.schedule.id === scheduleId
      )
      if (getDataByScheduleID === -1) {
        return console.log('nema zapisi s takim id')
      }
      const {
        retentionBalance,
        detailsCash,
        detailsCard,
        detailsTip,
        serviceCommission,
        parkCommission,
        driverPercent,
        fuel,
        readyCash,
        fixedSum,
        payExtraAmount,
        regionParkId,
        driverSelfEmployed,
        weekend,
        bonus,
        tollRoad,
        platformSelfemployedTax
      } = state.table[getDataByScheduleID]?.schedule

      const getRetentionsToExecRealCurrentAmount = (row) => {
        const {
          fixed_sum,
          currentAmount,
          execAmount,
          newSum
        } = row
        if (newSum) {
          return newSum
        }
        if (fixed_sum) {
          return currentAmount
        }
        return execAmount
      }
      const getRetentionsTotalSum = (retentionList) => {
        return (
          (
            retentionList.reduce(
              (acc, retention) =>
                acc + getRetentionsToExecRealCurrentAmount(retention),
              0
            ) - retentionBalance
          ).toFixed(2) || 0
        )
      }
      // const company_percent = Number((1 - driverPercent).toFixed(2))
      // const surcharge_sum = 1
      const surchargeSum = payExtraAmount
      const retentionSum = Number(
        getRetentionsTotalSum(
          state.table[getDataByScheduleID]?.retentionsExecs
        )
      )

      // commit(START_LOADING)
      const formulaResponse = await dispatch(
        'configurator/formulaCheck',
        {
          data: {
            regionParkId: regionParkId || state.currentRegionParkID,
            surchargeSum,
            detailsCash,
            detailsCard,
            detailsTip,
            serviceCommission,
            parkCommission,
            driverPercent,
            fuelSum: fuel,
            retentionSum,
            cash: readyCash,
            fixedSum,
            driverSelfEmployed,
            weekend,
            bonus,
            tollRoad,
            platformSelfemployedTax
          }
        },
        { root: true }
      )
      // const formulaResponse = await formulaCheck({
      //   data: { company_percent, retention_sum, details_cash, details_card, details_tip, service_commission, park_commission, driver_percent, fuel_sum: fuel, surcharge_sum },
      //   region_park_id: state.currentRegionParkID
      // })
      commit(UPDATE_SCHEDULE, {
        scheduleId,
        formulaResponse
      })
    } catch (e) {
      return Promise.reject(e)
    } finally {
      // await formulaCheck({ ...data })
      commit(STOP_LOADING)
    }
    // const getMaxRetentionsTypes = rootState.settings.retentionsMinMax?.max
    // if (!getMaxRetentionsTypes) return
    // commit(UPDATE_TENANS_INFO_BY_MAX_RETENTIONS, { scheduleId, maxRetentions: getMaxRetentionsTypes, retentionTypes: rootGetters['settings/getTransactionTypesToDropdown'] })
  },
  async getDriverPerscentsOnSettingsByPark (
    {
      commit,
      dispatch,
      rootState,
      rootGetters,
      rootActions,
      state
    },
    scheduleId
  ) {
    const getDriverByScheduleId = state.table.filter(
      (x) => x.schedule.id === scheduleId
    )
    const getGlobalSettingsPerscents = () => {
      const getDriversPercentsInSettings =
        rootState?.settings?.data?.driversPercents
      return {
        percents: getDriversPercentsInSettings,
        park: {}
      }
    }
    if (getDriverByScheduleId?.length === 0) {
      return getGlobalSettingsPerscents()
    }
    const { regionParkId } = getDriverByScheduleId[0].schedule
    if (!regionParkId) {
      return getGlobalSettingsPerscents()
    }
    const getSettingsRegionParkById = await dispatch(
      'settings/getDriverPerscentsRegionPark',
      { regionParkId },
      { root: true }
    )
    const getSettingsCummonRegionParkById =
      await rootGetters['regionPark/getRegionalCarParkByID'](regionParkId)
    const driversPercents = getSettingsRegionParkById?.driversPercents

    if (
      (!driversPercents || typeof driversPercents !== 'string') &&
      !Array.isArray(driversPercents)
    ) {
      return getGlobalSettingsPerscents()
    }
    const parseJsonPerscents = (driversPercents) => {
      if (Array.isArray(driversPercents)) return driversPercents
      try {
        return JSON.parse(driversPercents)
      } catch (e) {
        return JSON.parse(JSON.parse(driversPercents))
      }
    }
    return {
      percents: parseJsonPerscents(driversPercents),
      park: {
        id:
          getSettingsCummonRegionParkById?.regionParkId ??
          getSettingsCummonRegionParkById?.id,
        name: getSettingsCummonRegionParkById?.name
      }
    }
  },
  async getGlobalSettingsOrRegional (
    {
      commit,
      dispatch,
      rootState,
      rootGetters,
      rootActions,
      state
    },
    scheduleId
  ) {
    const getDriverByScheduleId = state.table.filter(
      (x) => x.schedule.id === scheduleId
    )
    const getGlobalSettingsPerscents = () => {
      const getGlobalSettings = rootState?.settings?.data
      return {
        data: getGlobalSettings,
        park: {}
      }
    }
    if (getDriverByScheduleId?.length === 0) {
      return getGlobalSettingsPerscents()
    }
    const { regionParkId } = getDriverByScheduleId[0].schedule
    if (!regionParkId) {
      return getGlobalSettingsPerscents()
    }
    const getSettingsRegionParkById = await dispatch(
      'settings/getAllSettingsReturn',
      { regionParkId },
      { root: true }
    )
    const getSettingsCummonRegionParkById =
      await rootGetters['regionPark/getRegionalCarParkByID'](regionParkId)

    return {
      data: getSettingsRegionParkById,
      park: {
        id:
          getSettingsCummonRegionParkById?.regionParkId ??
          getSettingsCummonRegionParkById?.id,
        name: getSettingsCummonRegionParkById?.name
      }
    }
  },
  async getMaxRetentionsByRegionalPark (
    {
      dispatch,
      rootState
    },
    {
      sheduleId,
      typeId
    }
  ) {
    if (!typeId || !sheduleId) return false
    const { data } = await dispatch('getGlobalSettingsOrRegional', sheduleId)
    const getRetentionTypes = rootState?.settings?.data?.retentionTypes
    const getRetentionNameById = getRetentionTypes.filter(
      (x) => x.id === typeId
    )
    if (!getRetentionNameById.length) return false

    const nameRetentionById = getRetentionNameById[0].name
    const getMaxRetentionByName = data?.minMaxRetentions?.maxes?.filter(
      (y) => y.name === nameRetentionById
    )
    if (!getMaxRetentionByName?.length) return false

    return getMaxRetentionByName[0]?.value
  },

  filterTenantsData ({ commit }, data) {
    const now = new Date()
    Object.entries(data.regionParksMeta).forEach(
      ([regionParkId, regionParkData]) => {
        const [date, shiftType] = getDateAndShiftByTimeHelper(
          regionParkData.shiftBorders,
          now
        )

        commit('AddRegionParksMeta', {
          regionParkId,
          currentShiftDateInPark: date,
          currentShiftTypeInPark: shiftType,

          ...regionParkData
        })
      }
    )
  },
  async updateShiftEarnings ({}, scheduleId) {
    try {
      const workerRep = new WorkerRepository()

      return await workerRep.updateShiftEarnings({ scheduleId: scheduleId })

    } catch (e) {

    }
  },

  async fetchDriversIncomeHistory (
    {
      commit,
      state,
      dispatch
    },
    { prevShiftId = false }
  ) {
    try {
      commit(START_LOADING)

      let {
        change,
        start_date: startDate,
        end_date: endDate,
      } = state.filters

      if (change === 'all') change = undefined

      const data = await Api.tenants.income.getTenantsIncomeHistory({
        change,
        startDate: getUtcFromDate(startDate),
        endDate: getUtcFromDate(endDate),
        regionParkId: state.currentRegionParkID,
        carId: state.carIds
      })

      const result = await dispatch('filterTenantsData', data)

      console.log(result, 'отфильтрованныфй объект данных')

      const dataDetails = await dispatch(
        'getDriversIncomeHistoryDetails',
        prevShiftId
      )

      commit(SET_META_CARS, data.carsMeta)

      commit(INIT_HIST_TABLE, {
        data: data.tenantsIncomes,
        prevShiftId,
        dataDetails
      })
      commit(STOP_LOADING)
    } catch (e) {
      return Promise.reject(e)
    } finally {
      commit(STOP_LOADING)
    }
  },
  async handleSetCarsIds ({
    commit,
    dispatch
  }, carIds) {
    commit(SET_CAR_IDS, carIds)
  },

  async fetchDriversIncomeHistoryDetails ({
    commit,
    state
  }, shiftId) {
    try {
      if (!shiftId) return
      const isActual = state.table.some(
        (x) => x?.retentions && x.schedule.id === shiftId
      )
      if (isActual) return
      commit(START_LOADING)
      const data = await Api.tenants.income.getTenantsIncomeDetails(shiftId)
      commit(ADD_DETAILS_TO_INCOME, {
        data,
        shiftId
      })
      commit(STOP_LOADING)
    } catch (e) {
      return Promise.reject(e)
    } finally {
      commit(STOP_LOADING)
    }
  },
  async getDriversIncomeHistoryDetails ({
    commit,
    state
  }, shiftId) {
    try {
      if (!shiftId) return
      const response =
        await Api.tenants.income.getTenantsIncomeDetails(shiftId)
      return response
    } catch (e) {
      return Promise.reject(e)
    } finally {
      commit(STOP_LOADING)
    }
  },

  async fetchDriversIncomeHistoryDetailsAll ({ commit }, data) {
    try {
      const response =
        await Api.tenants.income.getTenantsIncomeDetailsAll(data)
      return response
    } catch (e) {
      return Promise.reject(e)
    }
  },

  async requestCalculateAllDrivers (_, data) {
    try {
      const response = await Api.tenants.income.calculateAllDrivers(data)
      return response
    } catch (e) {
      return Promise.reject(e)
    }
  },

  prepareRetentions (_, retentionsExecs) {
    const result = retentionsExecs.map((currentRetention) => {
      const {
        transactionId,
        type,
        amount,
        managerComment
      } = currentRetention
      const getRetentionsToExecRealCurrentAmount = (row) => {
        const {
          fixed_sum,
          currentAmount,
          execAmount,
          newSum
        } = row

        if (newSum) return newSum
        if (fixed_sum) return currentAmount

        return execAmount
      }
      return {
        id: Number(transactionId),
        type,
        amount,
        currentAmount: getRetentionsToExecRealCurrentAmount(currentRetention),
        managerComment
      }
    })

    return result
  },

  prepareSurcharges (_, surcharges) {
    const result = surcharges.map((currentSurcharge) => {
      const {
        id,
        type,
        amount,
        currentAmount
      } = currentSurcharge
      return {
        id,
        type,
        amount,
        currentAmount: amount
      }
    })
    return result
  },

  async calculateAllDrivers ({
    state,
    dispatch,
    commit,
    getters
  }, calculationType) {

    if (getters.notCommitedDrivers.length < 1) return

    const data = {
      startDate: getUtcFromDate(state.filters.start_date),
      endDate: getUtcFromDate(state.filters.end_date),
      change: state.filters.change,
      regionParkId: state.currentRegionParkID
    }
    commit(START_LOADING)

    const response = await dispatch(
      'fetchDriversIncomeHistoryDetailsAll',
      data
    )

    commit(STOP_LOADING)
    for (const index in response.retentionsDetails) {
      const item = response.retentionsDetails[index]
      const isActual = state.table.some(
        (x) => x?.retentions && x.schedule.id === item.scheduleId
      )

      if (isActual) continue

      commit(ADD_DETAILS_TO_INCOME, {
        data: item.retentionDetails,
        shiftId: item.scheduleId
      })
    }

    const approveCalcRequests = []
    const drivers = [...getters.notCommitedDrivers]
    let ignoreSchedulesInProcess = false

    for (const index in drivers) {
      const e = drivers[index]
      const actionAllowed = await dispatch('checkCanDriversCalculate', e.schedule)

      if (e.schedule.isCalculated) continue

      if (!actionAllowed) {
        showErrorMessage(
          `${e.schedule.driverName} нельзя рассчитать - смена не завершена!`
        )

        if (!ignoreSchedulesInProcess) {
          const result = await confirmWarning('Игнорировать не завершенные смены? Или остановить расчет?', {
            confirmText: 'Игнорировать',
            cancelText: 'Остановить'
          })

          if (!result) return

          ignoreSchedulesInProcess = true
        }

        continue
      }

      if (e.schedule.driverPercent <= 0) {
        showErrorMessage(
          'У всех водителей должен быть выставлен "% дохода..." больше 0'
        )
        return
      }

      const retentions = await dispatch('prepareRetentions', e.retentionsExecs)
      const surcharges = await dispatch('prepareSurcharges', e.surcharges)

      approveCalcRequests.push({
        shiftId: e.schedule.id,
        companyProfit: e.schedule.companyProfit,
        driverCompensation: e.schedule.driverCompensation,
        giveOutAmount: e.schedule.giveOutAmount,
        earnAmount: e.schedule.earnAmount,
        retentions,
        surcharges,
      })
    }

    return await dispatch('requestCalculateAllDrivers', {
      approveCalcRequests,
      calculationType
    })
  },
  async setParamsFilters ({ commit }, data) {
    try {
      commit(SET_FILTERS, data)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async fetchNotCalkedDays ({
    commit,
    state
  }) {
    try {
      const endDate = moment().subtract(30, 'days').format('YYYY-MM-DD')
      const startDate = moment().format('YYYY-MM-DD')
      const response = await Api.schedule.index.getSchedulesNotCalculated({
        startDate: getUtcFromDate(startDate),
        endDate: getUtcFromDate(endDate),
        regionParkId: state.currentRegionParkID
      })

      commit(INIT_NOT_CALKED_DAYS, response)
    } catch (e) {
      return Promise.reject(e)
    }
  },

  async deleteDriverIncomeData ({
    commit,
    dispatch
  }, shiftId) {
    try {
      await Api.tenants.income.deleteTenantIncome({ shiftId })
      await dispatch(
        'worker/updateScheduleTask',
        { scheduleId: shiftId },
        { root: true }
      )
      await dispatch('fetchDriversIncomeHistory', {})
      Message({
        type: 'success',
        message: 'Удержание удаленно!'
      })
    } catch (err) {
      debugger
      Message({
        message: 'Не удалось удалить удержание',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(err)
    }
  },

  async downloadExcel (_, dto) {
    try {
      const response = await Api.tenants.income.generateIncomeExel(dto)
      return response
    } catch (e) {
      return Promise.reject(e)
    }
  },

  commitSurcharge ({ commit }, commitSurchargeDto) {
    commit(COMMIT_SURCHARGE, commitSurchargeDto)
  },

  cancelSurcharge ({ commit }, cancelSurchargeDto) {
    commit(CANCEL_SURCHARGE, cancelSurchargeDto)
  },

  setCompensation ({ commit }, params) {
    commit(SET_COMPENSATION, params)
  },
  setFilterDriverId ({ commit }, id) {
    commit(SET_DRIVER_ID, id)
  },
  async commitTenantIncome ({
    dispatch,
    state
  }, {
    id,
    driver,
    data,
    query
  }) {
    try {
      const getCurrentMethod =
        data.calculationType === 'registry'
          ? 'approveDriverCalculationRegistry'
          : 'approveDriverCalculationBalance'
      const {
        success,
        detail
      } = await Api.tenants.income[getCurrentMethod](
        id,
        data
      )
      if (!success) {
        Message({
          message: detail || 'Не удалось рассчитать водителя',
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.reject(success)
      }

      await dispatch('fetchDriversIncomeHistory', {})
    } catch (e) {
      const { data } = e.response
      Message({
        message: data.detail || 'Не удалось рассчитать водителя',
        type: 'error',
        duration: 5 * 1000
      })
      return data
    }
  },

  async createRetentionTransaction (
    {
      commit,
      rootGetters,
      state,
      dispatch
    },
    data
  ) {
    try {
      const parkId = rootGetters['userStore/getActualPark']().id
      const response = await Api.tenants.transaction.createTransaction({
        ...data,
        parkId
      })
      await dispatch(
        'worker/updateScheduleTask',
        { scheduleId: data?.shiftId },
        { root: true }
      )
      await dispatch('fetchDriversIncomeHistory', {
        prevShiftId: data?.shiftId
      })
      Message({
        type: 'success',
        message: 'Транзакция успешна!'
      })
      return response
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async deleteTransaction ({
    commit,
    state,
    dispatch
  }, data) {
    const {
      transactionId,
      shiftId
    } = data
    const { responseState } = await Api.tenants.transaction.deleteTransaction(
      { transactionId }
    )
    const {
      success,
      detail
    } = responseState
    if (!success) {
      return Message({
        type: 'error',
        message: detail || 'Ошибка при удалении'
      })
    }
    await dispatch(
      'worker/updateScheduleTask',
      { scheduleId: shiftId },
      { root: true }
    )
    await dispatch('fetchDriversIncomeHistory', { prevShiftId: shiftId })
    Message({
      type: 'success',
      message: 'Транзакция удалена'
    })
  },
  async callUpdateScheduleFiveMinutely ({
    commit,
    state,
    dispatch
  }, params) {
    commit(START_LOADING)
    await Api.worker.updateScheduleForDriverTask({ ...params })
    const history = await dispatch('fetchDriversIncomeHistory', {
      ...state.filters,
      change: state.filters?.change === 'all' ? null : state.filters?.change
    })
    commit(INIT_HIST_TABLE, history)
    commit(STOP_LOADING)
  },

  async createTransactionDriver (
    {
      commit,
      rootGetters,
      state,
      dispatch
    },
    { createRetentionDto }
  ) {
    try {
      const {
        type: typeId,
        driverId,
        amount,
        current_amount: currentAmount,
        comment
      } = createRetentionDto
      const response =
        await Api.tenants.transaction.createTransactionFromDriver({
          typeId,
          amount,
          currentAmount,
          driverId,
          comment
        })
      Message({
        type: 'success',
        message: 'Удержание назначено водителю'
      })
      // if (!data?.success) {
      //   Message({
      //     type: 'error',
      //     message: data.details || 'Не удалось добавить удержание'
      //   })
      // }

      return response
    } catch (e) {
      Message({
        type: 'error',
        message: 'Не удалось добавить удержание'
      })

      return Promise.reject(e)
    }
  },
  async createSurcharge ({
    commit,
    state,
    dispatch
  }, surchargeDto) {
    try {
      const { schedule_date } = await createTransactionData(surchargeDto)
      await callUpdateScheduleFiveMinutely({
        date: schedule_date,
        schedule_id: surchargeDto.schedule
      })
      await dispatch('fetchDriversIncomeHistory', {
        prevShiftId: surchargeDto.schedule
      })
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async updateIncomeHistoryByStateFilters ({
    commit,
    state
  }) {
    try {
      commit(START_LOADING)
      const history = await getDriversIncomeHistoryData({ ...state.filters })
      commit(INIT_HIST_TABLE, history)
      commit(STOP_LOADING)
    } catch (err) {
      commit(STOP_LOADING)
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async patchRetention (
    {
      commit,
      dispatch
    },
    {
      scheduleId,
      transactionId,
      patchRetentionDto
    }
  ) {
    try {
      await Api.tenants.income.defrayTransaction(transactionId, {
        ...patchRetentionDto
      })
      await dispatch(
        'worker/updateScheduleTask',
        { scheduleId },
        { root: true }
      )
      await dispatch('fetchDriversIncomeHistory', { prevShiftId: scheduleId })
    } catch (e) {
      return Promise.reject(e)
    }
  },

  commitRetention ({ commit }, commitRetentionDto) {
    commit(COMMIT_RETENTION, commitRetentionDto)
  },

  cancelRetention ({ commit }, {
    driverId,
    scheduleId,
    retentionId
  }) {
    commit(CANCEL_RETENTION, {
      driverId,
      scheduleId,
      retentionId,
    })
  },

  async sendSurcharge ({ dispatch }, surchargeDto) {
    try {
      const {
        transaction_id: transactionId,
        surcharge_schedule: surchargeSchedule,
        surcharge_sum: surchargeSum,
        company_profit: companyProfit,
        date
      } = surchargeDto
      await Api.tenants.income.setSurcharge({
        transactionId,
        surchargeSchedule,
        surchargeSum,
        companyProfit,
        date
      })
      await dispatch(
        'worker/updateScheduleTask',
        { scheduleId: surchargeSchedule },
        { root: true }
      )
      await dispatch('fetchDriversIncomeHistory', {
        prevShiftId: surchargeSchedule
      })
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },

  async changeDriversPercent ({
    state,
    commit,
    dispatch
  }, body) {
    try {
      await Api.tenants.income.changeShiftPercent(body)
      await dispatch(
        'worker/updateScheduleTask',
        { scheduleId: body?.shiftId },
        { root: true }
      )
      await dispatch('fetchDriversIncomeHistory', {
        prevShiftId: body?.shiftId
      })
      Message({
        type: 'success',
        message: 'Процент успешно изменен'
      })
      // commit(CHANGE_PERSCENT_BY_ID, { id: body.shiftId, newPercent: body.newDriverPercent })
      // dispatch('updateRetentionByFormula', { scheduleId: body.shiftId })

      // const { date } = state.table.find(d => d.schedule.id === body.shiftId)?.schedule
      // if (!date) return
      // await callUpdateScheduleFiveMinutely({ date, schedule_id: body.shiftId })
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async getHistorySettingsSchanges ({ commit }, shiftId) {
    try {
      const data = await Api.tenants.income.getHistoryChangeSettings({
        shiftId: shiftId
      })
      commit(SET_HISTORY_SETTINGS_CHANGES, data)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async changeTransactionsChange ({
    commit,
    dispatch
  }, schedule_id) {
    try {
      const response =
        await Api.tenants.income.transferTransactionsToNextSchedule(
          schedule_id
        )

      if (response.nextShiftId !== '-1') {
        await dispatch(
          'worker/updateScheduleTask',
          { scheduleId: response.nextShiftId },
          { root: true }
        )
      }

      await dispatch(
        'worker/updateScheduleTask',
        { scheduleId: schedule_id },
        { root: true }
      )
      await dispatch('fetchDriversIncomeHistory', { prevShiftId: schedule_id })
      Message({
        type: 'success',
        message: 'Сменна успешно изменена'
      })
    } catch (err) {
      Message({
        type: 'error',
        message: 'Произошла ошибка при переносе транзакции'
      })
      return Promise.reject(err)
    }
  },
  async getDriverOpenTransactions ({ commit }, driverId) {
    try {
      const response = await Api.tenants.index.getDriverTransactionsIsOpen({
        driverId
      })

      return response
    } catch (err) {
      showErrorMessage('Произошла ошибка')
    }
  },

  async getDriverTransactions ({ commit }, transactionId) {
    try {
      const response =
        await Api.tenants.index.getDriverTransactionsInModal(transactionId)

      return response.openTransactions
    } catch (err) {
      showErrorMessage('Произошла ошибка')
    }
  },

  async getDriverOpenTransactionsInfo ({ commit }, transactionId) {
    try {
      const response = await getDriverOpenTransactionsInfo(transactionId)

      return response
    } catch (err) {
      showErrorMessage('Произошла ошибка')
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
